import {SmartComponent} from "smart-component-js";
import Swiper, {Navigation, Pagination} from "swiper";

class ConversationalToolComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.container = this.element.querySelector('.conversational-tool__container');
        this.textTypingLoader = this.element.querySelector('.text-typing');
        this.currentLevel = 1;
        this.init();
    }

    getUrlParam() {
        const urlParams = new URLSearchParams(window.location.search);
        this.area = urlParams.get('area');
        this.id = urlParams.get('id');
        this.idArea = urlParams.get('idArea');
    }

    appendQuestion(data) {
        this.data = data;
        // console.log('appendQuestion: data = ' + JSON.stringify(data));
        //  const type = data.answers[0].type;
        const html = `
            <div class="conversational-tool__wrapper question" data-level="${this.currentLevel}">
                <img class="conversational-tool__avatar" alt="avatar" src="/fe-web/img/hdiassicurazioni/images/conversational-tool-avatar.png"/>
                <div class="conversational-tool__question">${data.label}</div>
              
              ${this.fragmentAllType(data.answers)}
                
          <!--
              
                <div class="conversational-tool__options {type === "product" ? 'swiper' : ''}">
                    {type !== "product" ? this.getOptions(data.answers) : this.getProducts(data.answers)}
                </div>
            
            -->
            </div>
            
        `;
        this.container.insertAdjacentHTML('beforeend', html);
        //if (type === "product") this.initSwiper();
        this.initSwiper();
        this.setAnimations();
    }

    fragmentAllType(options = "") {

        let html = '';
        if (typeof options === 'string') {
            html = `<div class="conversational-tool__options">${options} </div>`;
            return html;
        }
        if (Array.isArray(options)) {
            const hasFlowQuestion = options.some(option => option.type === 'flowQuestion');
            if (options[0].type === 'text') {
                html = `<div class="conversational-tool__options">` + this.getOptionFlow(options, null) + `</div>`;
                return html;
            } else if (hasFlowQuestion) {
                const optionsFlowQuestions = options.filter(option => option.type === 'flowQuestion');
                const optionsProducts = options.filter(option => option.type === 'product');
                let indexFlowQ = optionsFlowQuestions.length;
                html = `<div>
                          <div class="conversational-tool__optionsP swiper">` + this.getProductOrWarranty(optionsProducts) + `</div>
                          <div class="conversational-tool__options">` + this.getOptionFlow(optionsFlowQuestions, indexFlowQ) + `</div>
                       </div>`;
                return html;
            } else {
                html = `<div class="conversational-tool__options swiper">` + this.getProductOrWarranty(options) + `</div>`;
                return html;
            }
        }
    }

    getOptionFlow(options = '', indexFlowQ) {
        let html = '';
        options.forEach((option, index) => {
            // console.log('getOptionFlow: option = ' + JSON.stringify(option));
            if (option.type === 'text') {
                html += `
            <div class="conversational-tool__item" data-index="${index}">
                ${option.icon ? `<img src="${option.icon}" alt="${option.label}">` : ''}
                <span>${option.label}</span>
            </div>`;
            }
            if (option.type === 'flowQuestion') {
                html += `
                <div class="conversational-tool">
                     <div class="single-card__card-info-text">
                        <div class="single-card__description">${option.cardDescription}</div>
                    </div>
                    
                     <div class="conversational-tool__button-offer conversational-tool__item" data-index="${indexFlowQ}">Personalizza l'offerta</div> 
                </div>`;
            }
        });
        console.log('getOptionFlow, html=' + html);
        return html;
    }


    getProductOrWarranty(options = "") {
        let htmlProduct = '';
        let htmlWarranty = '';
        options.forEach((option) => {
            if (option.type === 'product') {
                htmlProduct += this.getProductHtml(option);
            } else {
                htmlWarranty += this.getWarrantyHtml(option);
            }
        });
        return `<div class="conversational-tool__container-warrancy">${htmlWarranty}</div> <div class="conversational-tool__container-extra-info-card">${htmlProduct}</div>`;
    }

    getWarrantyHtml(option = '') {
        return `
        <div class="extra-info-card">
            <a class="extra-info-card__expandable">
                <div class="extra-info-card__button-container">
                    <div class="extra-info-card__title-container">
                        <img src="${option.icon}" alt="icon"/>
                        <span class="extra-info-card__title-button">${option.name}</span>
                    </div>
                </div>
            </a>
        </div>`;
    }


    getOptions(options = '') {
        let html = '';
        if (typeof options === 'string') {
            html = options;
        } else if (Array.isArray(options)) {
            options.forEach((option, index) => {
                html += `
            <div class="conversational-tool__item" data-index="${index}">
                ${option.icon ? `<img src="${option.icon}" alt="${option.label}">` : ''}
                <span>${option.label}</span>
            </div>`;
            });
        }

        return html;
    }

    getProducts(options) {
        let html = '';
        options.forEach((option) => html += this.getProductHtml(option));
        let navigation = ` 
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next"></div>`;
        return `<div class="swiper-wrapper">${html}</div> ${navigation}`;
    }

    getProductHtml(option) {
        return `
        <div class="conversational-tool__product swiper-slide">
            <a class="single-card full-image" href="${option.link}">
                <div class="single-card__image-container">
                    <img src="${option.cardImage}" alt="${option.name} image" class="single-card__image"/>
                    ${option.promotion ? `<div class="single-card__discount">${option.promotion}</div>` : ''}
                </div>
    
                <div class="single-card__card-info">
                    <div class="single-card__card-info-text">
                        <h1 class="single-card__title-card">${option.name}</h1>
                        <div class="single-card__description">${option.cardDescription}</div>
                    </div>
                    <img src="/fe-web/img/hdiassicurazioni/icons/chevron-right-grey.svg" alt="chevron right"
                         class="single-card__icon"/>
                </div>
            </a>
            
            <a class="conversational-tool__button" href="${option.link}">${GENERIC_TRANSLATION.conversationalTool.goToProduct}</a> 
            <a class="conversational-tool__secondary-button" href="${GENERIC_TRANSLATION.trovaAgenziaLink}">
                ${GENERIC_TRANSLATION.conversationalTool.moreInfo}
            </a> 
        </div>`;
    }

    setAnimations() {
        this.textTypingLoader.classList.add('visible');
        const questionElement = this.element.querySelector(`.question[data-level="${this.currentLevel}"]`);
        const wrapper = this.element.querySelector(`.question[data-level="${this.currentLevel}"] .conversational-tool__options`);
        setTimeout(() => this.textTypingLoader.classList.remove('visible'), 1000);
        setTimeout(() => questionElement.classList.add('pop'), 1100);
        this.data.answers && this.addItemListeners(wrapper);
        setTimeout(() => this.selectFirstQuestion(wrapper), 1600);

        setTimeout(() => this.selectSecondQuestion(wrapper), 2000);
    }

    selectFirstQuestion(wrapper) {
        if (this.currentLevel !== 1 || this.id === null) return;
        const item = wrapper.querySelector(`.conversational-tool__item[data-index="${this.id}"]`);
        if (!item) return;
        this.goToNextLevel(wrapper, item);
    }


    selectSecondQuestion() {
        if (this.currentLevel !== 2 || this.idArea === null) return;
        setTimeout(() => {
            const wrapper = this.element.querySelector(`.question[data-level="${this.currentLevel}"] .conversational-tool__options`);
            console.log("wrapper Second Level (dopo timeout)", wrapper);
            if (!wrapper) return;
            const item = wrapper.querySelector(`.conversational-tool__item[data-index="${this.idArea}"]`);

            if (!item) return;
            this.goToNextLevel(wrapper, item);
        }, 500); // Aspetta 50ms per dare tempo al DOM di aggiornarsi
    }


    addItemListeners(wrapper) {
        const items = wrapper.querySelectorAll('.conversational-tool__item');
        items.forEach((item) => item.addEventListener('click', () => this.goToNextLevel(wrapper, item)));
    }


    goToNextLevel(wrapper, item) {
        let index = item.dataset.index;
        if (index === undefined || isNaN(index) || this.data.answers[index] === undefined) {
            console.error("Indice non valido o answer inesistente:", index);
            return;
        }


        let dataNext = this.data.answers[index].question;
        if (dataNext == null) {
            console.warn("L'elemento selezionato non ha una domanda successiva.");
            return;
        }
        // wrapper.classList.add('hidden');
        this.appendAnswer(item);
        this.currentLevel++;
        this.data = dataNext;
        this.appendQuestion(this.data);
        setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 1100);
    }


    appendAnswer(item) {
        const htmlAnswer = `
            <div class="conversational-tool__wrapper answer" data-level="${this.currentLevel}">
                <img class="conversational-tool__avatar" alt="avatar"
                     src="/fe-web/img/hdiassicurazioni/images/conversational-tool-smile.png"/>
                <div class="conversational-tool__answer">${item.innerHTML}</div>
            </div>`;
        this.container.insertAdjacentHTML('beforeend', htmlAnswer);
        this.container.querySelector(`.answer[data-level="${this.currentLevel}"]`).classList.add('pop');
    }


    getConversations() {
        this.element.classList.add('absolute-loading');
        youserxp.ajax(`/api/1.0/hdi-assicurazioni/conversation/${this.area || 'privati'}`, {
            method: 'GET',
            auth: true
        }).then(
            (obj) => {
                this.appendQuestion(obj.body?.question);
                this.element.classList.remove('absolute-loading');
            },
            () => this.element.classList.remove('absolute-loading')
        );
    }


    initSwiper() {
        new Swiper(this.element.querySelector('.swiper'), {
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            },
            modules: [Navigation, Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        });
    }

    init() {
        this.getUrlParam();
        this.getConversations();
    }
}

export default ConversationalToolComponent;